<template>
  <responsive-drawer-header
    :badgeColor="'primary'"
    :moduleUnreadCount="unreadCountByModuleInstance[$route.params.instance]"
    :color="theme.appBar.other.color"
    :headerBg="theme.appBar.other.bg"
    :hasDrawer="false"
  >
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <div v-if="!hasGroupFilterInHeader" class="d-flex caption">Gruppen</div>
      <div v-else class="d-flex caption">{{ $t('alle Videos') }}</div>
    </template>
    <template v-if="hasGroupFilterInHeader" v-slot:right>
      <label-group v-if="hasGroupFilterInHeader" v-model="selectedGroupId" :labels="groupsByInstance" display-property="name"></label-group>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import common from '@/mixins/common';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import LabelGroup from '@/components/groups/LabelGroup';

export default {
  mixins: [common],
  components: {
    ResponsiveDrawerHeader,
    LabelGroup,
  },
  computed: {
    ...mapState('videos', ['groups', 'selectedGroup', 'dataLoaded', 'unreadCountByModuleInstance']),
    ...mapGetters('videos', ['sortedAndFilteredGroups']),
    selectedGroupId: {
      get() {
        return this.selectedGroup ? this.selectedGroup.id : null;
      },
      set(value) {
        console.debug('selectedGroup value', value);

        let selectedGroup = this.groups.find((g) => g.id === value);

        this.$store.commit('videos/setSelectedGroup', selectedGroup);
      },
    },
    groupsByInstance() {
      return this.sortedAndFilteredGroups.filter((group) => group.instance == this.$route.params.instance);
    },
    hasGroupFilterInHeader() {
      return this.groupsByInstance.length < 6;
    },
  },
};
</script>
